import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { LinkOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const MatchListItem = ({onClick}) => {
  const { t } = useTranslation('translations');

  return (
    <ListItemButton onClick={onClick}>
      <ListItemIcon>
        <LinkOutlined />
      </ListItemIcon>
      <ListItemText primary={t('menu.actionHeader.matchKulturnav')} />
    </ListItemButton>
  )
}